import { Link } from 'react-router-dom';

export default function Footer() {
  const quickLinks = [
    { to: '/', label: '首页' },
    { to: '/category/hypnosis-improve-intimacy', label: '催眠改善亲密关系' },
    { to: '/category/hypnosis-relax-stress', label: '催眠放松减压' },
    { to: '/category/self-hypnosis-techniques', label: '自我催眠技巧' },
    { to: '/about', label: '关于我们' },
  ];

  const hotArticles = [
    { to: '/article/hypnosis-rebuild-intimacy-connection', label: '催眠如何帮助伴侣重建亲密度' },
    { to: '/article/self-hypnosis-beginners-guide', label: '自我催眠入门指南' },
    { to: '/article/hypnosis-stress-relief-techniques', label: '催眠减压全攻略' },
    { to: '/article/hypnosis-heal-emotional-trauma', label: '催眠疗愈情感创伤' },
  ];

  return (
    <footer className="bg-secondary-800 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link
              to="/"
              className="flex items-center gap-2 text-xl font-heading font-semibold text-background-50 mb-4 whitespace-nowrap"
            >
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
                心
              </span>
              催眠性福生活
            </Link>
            <p className="text-sm text-background-200 leading-relaxed">
              探索催眠疗愈的科学应用，用潜意识的力量重塑亲密关系与幸福感，开启更满足的生活方式。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200 hover:text-primary-300 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门文章</h4>
            <ul className="space-y-2.5">
              {hotArticles.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200 hover:text-primary-300 transition-colors line-clamp-1"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-2.5 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                <span>contact@cuimianxingfu.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-base"></i>
                <span>北京市朝阳区建国路88号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-secondary-700">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-300">
              &copy; {new Date().getFullYear()} 催眠性福生活. 版权所有.
            </p>
            <div className="flex items-center gap-4">
              <Link to="/about" className="text-xs text-background-300 hover:text-primary-300 transition-colors whitespace-nowrap">
                隐私政策
              </Link>
              <Link to="/about" className="text-xs text-background-300 hover:text-primary-300 transition-colors whitespace-nowrap">
                服务条款
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}